import React, { useEffect } from "react";
import { Card, Col, Row, Spin, List } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getRapportById } from "../../../redux/slices/rapports/rapportsThunk";

// --- 1. IMPORTS DAYJS ET PLUGIN UTC ---
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

// On active le plugin UTC
dayjs.extend(utc);
// --------------------------------------

const Reportdetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { data, loading, error } = useSelector((state) => state.rapports.rapportByID || {});

  useEffect(() => {
    dispatch(getRapportById(id));
  }, [dispatch, id]);

  if (loading) {
    return (
      <div className="centered-content">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-message">
        <h2>Erreur: {error}</h2>
      </div>
    );
  }

  if (!data) return null;

  const renderInfoRow = (label1, value1, label2, value2) => (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12}>
        <p>
          <b>{label1}:</b> {value1 || "Non renseigné"}
        </p>
      </Col>
      <Col xs={24} md={12}>
        <p>
          <b>{label2}:</b> {value2 || "Non renseigné"}
        </p>
      </Col>
    </Row>
  );

  const renderSamples = () => (
    <List
      bordered
      dataSource={data.reportSamples}
      renderItem={(item) => (
        <List.Item>
          <b>Nom:</b> {item.sample.name} | <b>Quantité:</b> {item.quantity}
        </List.Item>
      )}
    />
  );

  const renderProducts = () => (
    <List
      bordered
      dataSource={data.reportProducts}
      renderItem={(item) => (
        <List.Item>
          <b>Nom:</b> {item.product.name} | <b>Potentiel:</b> {item.potential}
        </List.Item>
      )}
    />
  );

  return (
    <div className="tabled">
      <Card>
        <Card style={{ marginBottom: 20 }} bordered={false} className="report-details-card" title="Détails du rapport">
          {renderInfoRow(
            "Nom", 
            `${data.delegate?.firstname} ${data.delegate?.lastname}`, 
            "Date de rapport", 
            
            // --- 2. CORRECTION ICI : ON FORCE L'AFFICHAGE EN UTC ---
            // Cela empêche d'ajouter +1h (Tunisie) à l'heure stockée.
            // Si la base contient 11:00, cela affichera 11:00.
            data.date ? dayjs(data.date).utc().format("DD/MM/YYYY HH:mm") : "N/A"
            // -------------------------------------------------------
          )}
          {renderInfoRow("Durée", `${data.duration} minutes`, "Spécialité", data.specialty)}
          {renderInfoRow("Note", data.note, "Statut", data.status)}
          {renderInfoRow("Région", data.region?.name, "Gouvernement", data.government?.name)}
        </Card>

        <Card title="Échantillons donnés" className="samples-info-card">
          {renderSamples()}
        </Card>

        <Card title="Produits donnés" className="products-info-card">
          {renderProducts()}
        </Card>

        <Card title="Informations sur la cible de la visite" className="target-info-card">
          {renderInfoRow("Nom", `${data.person?.firstname} ${data.person?.lastname}`, "Adresse", data.person?.address)}
          {renderInfoRow("Numéro de téléphone", data.person?.phoneNumber, "Email", data.person?.email)}
          {renderInfoRow("Gouvernement du cible", data.person?.government?.name, "Région du cible", data.person?.region?.name)}
        </Card>
      </Card>
    </div>
  );
};

export default Reportdetails;